import type { NotificationChannel, NotificationKind } from "@bezbolisno/contracts/notifications";
import { queryOptions } from "@tanstack/react-query";
import { api, expectOk } from "../../../lib/api";
import { keys } from "../../../lib/keys";

export type PreviewTheme = "light" | "dark";

/** The page's one read: the policy, channel availability, the catalogue, who saved last. */
export const notificationSettingsQuery = queryOptions({
  queryKey: keys.notificationSettings,
  queryFn: async () => expectOk(await api.notifications.settings({}), 200),
});

/** A rendered sample — the same template and renderer the worker uses. */
export const notificationPreviewQuery = (
  kind: NotificationKind,
  channel: NotificationChannel,
  theme: PreviewTheme,
) =>
  queryOptions({
    queryKey: keys.notificationPreview(kind, channel, theme),
    queryFn: async () =>
      expectOk(await api.notifications.preview({ body: { kind, channel, theme } }), 200),
    staleTime: 5 * 60_000,
  });

export const notificationDeliveriesQuery = queryOptions({
  queryKey: keys.notificationDeliveries,
  queryFn: async () => expectOk(await api.notifications.deliveries({ query: { limit: 20 } }), 200),
  refetchInterval: 30_000,
});
